"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var MetadataHierarchyRowDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(MetadataHierarchyRowDTO, _DomainObject_1$Domai);

  /**
   * https://docs.google.com/document/d/12D4mfbkpEKoFNhCimYUbwd33SYh_xUeNH25dyxuDw5A/edit
   * @param categoryExternalId
   * @param categoryName
   * @param categoryNumber
   */
  function MetadataHierarchyRowDTO(categoryExternalId, categoryName, categoryNumber) {
    var _this;

    _classCallCheck(this, MetadataHierarchyRowDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MetadataHierarchyRowDTO).call(this));
    _this.categoryExternalId = categoryExternalId;
    _this.categoryName = categoryName;
    _this.categoryNumber = categoryNumber;
    return _this;
  }

  return MetadataHierarchyRowDTO;
}(DomainObject_1.DomainObject);

exports.MetadataHierarchyRowDTO = MetadataHierarchyRowDTO;

MetadataHierarchyRowDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(MetadataHierarchyRowDTO.name);
  return {
    categoryExternalId: builder.str('categoryExternalId'),
    categoryName: builder.str('categoryName'),
    categoryNumber: builder.num('categoryNumber')
  };
}();

MetadataHierarchyRowDTO.dataOrder = [MetadataHierarchyRowDTO.schema.categoryExternalId.simpleNameKey(), MetadataHierarchyRowDTO.schema.categoryName.simpleNameKey(), MetadataHierarchyRowDTO.schema.categoryNumber.simpleNameKey()];